var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconachiamatabianca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_40",
    "data-name": "Raggruppa 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_18",
    "data-name": "Rettangolo 18",
    width: 27,
    height: 27,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_17",
    "data-name": "Raggruppa 17",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32",
    "data-name": "Tracciato 32",
    d: "M13.411,0A13.411,13.411,0,1,0,26.822,13.411,13.411,13.411,0,0,0,13.411,0m7.082,19.568-1.074,1.074a1.977,1.977,0,0,1-.771.311A12.665,12.665,0,0,1,5.867,8.143a2,2,0,0,1,.314-.737L7.256,6.332a1.794,1.794,0,0,1,1.676-.4l.226.075a2.122,2.122,0,0,1,1.226,1.3l.54,1.982a1.944,1.944,0,0,1-.444,1.7l-.717.717a7.615,7.615,0,0,0,5.355,5.356l.717-.717a1.942,1.942,0,0,1,1.7-.445l1.982.542a2.124,2.124,0,0,1,1.3,1.225l.075.229a1.8,1.8,0,0,1-.394,1.673",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconachiamatabianca);
export default __webpack_public_path__ + "static/media/iconachiamatabianca.872e83e2e5f2f0540ff341cb27815a34.svg";
export { ForwardRef as ReactComponent };